<template>
    <div class="w-fit p-2 ml-3 mb-4 bg-base-100 border border-base-300">
        <input v-model="numNewEntities" class="bg-transparent outline-none" autocomplete="off">
        <button class="btn btn-primary btn-sm" :disabled="isLoading" @click="handleAddMany"> {{ isLoading ? 'Laster' : 'Opprett mange' }}</button>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {fetchCustomers, fetchSuppliers} from '@/subaccount/subAccount.service'
import {generateCustomers, generateSuppliers} from '@/dummy-generator/DummyGenerator.service'
import {notifyError} from '@/services/infrastructure/notification.service'

const isLoading = ref(false)

const props = defineProps({
    isCustomer: {type: Boolean, default: true}
})

const numNewEntities = ref(10)

const handleAddMany = async () => {
    isLoading.value = true
    try {
        if (props.isCustomer) {
            await generateCustomers(numNewEntities.value)
        } else {
            await generateSuppliers(numNewEntities.value)
        }
    } catch (error) {
        notifyError({title: 'Feilet', description: {descriptionMessage: `Klarte ikke å generere ${numNewEntities.value} ${props.isCustomer ? 'kunder.' : 'leverandører.'}`, error}})
    } finally {
        if (props.isCustomer) {
            await fetchCustomers()
        } else {
            await fetchSuppliers()
        }
        isLoading.value = false
    }
}
</script>

<style>

</style>